import React from 'react';
import {useState, useEffect} from "react";
import useMedicalEvents from "./Hooks/useMedicalEvents";
import {hasFailed, isLoading} from "../../../Shared/StateHelper";
import Loader from "../../../Shared/Loader";
import Error from "../../../Shared/Error";
import {MedicalEventStatus} from "./Enums/Enums";
import {Link, useNavigate} from "react-router-dom";
import {UserPermissions, UserRights} from "../../../Shared/Enums/Enums";
import RestrictedElement from "../../../Shared/RestrictedElement";
import RestrictedPage from "../RestrictedPage";
import LinkHandler from "./LinkHandler";

const MedicalEvents = () => {
    const [search, setSearch] = useState("")
    const [debouncedSearch, setDebouncedSearch] = useState(search)
    const [showAll, setShowAll] = useState(false)
    const [page, setPage] = useState(1)
    const {medicalEvents, state} = useMedicalEvents({
        filter: debouncedSearch,
        showAll: showAll,
        page: page,
        enabled: true
    })
    const nav = useNavigate()


    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedSearch(search)
            setPage(1)
        }, 250)
        return () => clearTimeout(timeout)
    }, [search])

    const renderStatus = (status) => {
        switch (status) {
            case MedicalEventStatus.SCHEDULED:
                return <i className="material-icons grey-text" title={"L'évènement est en attente"}>schedule</i>
            case MedicalEventStatus.IN_PROGRESS:
                return <i className="material-icons orange-text" title={"L'évènement est en cours"}>pending</i>
            case MedicalEventStatus.COMPLETED:
                return <i className="material-icons green-text" title={"L'évènement est terminé"}>done</i>
            case MedicalEventStatus.CANCELED:
                return <i className="material-icons red-text" title={"L'évènement est annulé"}>error</i>
            default:
                return null
        }
    }

    // const filteredEvents = medicalEvents
    //     .filter(event => event.name?.toLowerCase().includes(search.toLowerCase()))
    //     .sort((a, b) => new Date(b.date) - new Date(a.date));

    const renderSearchBar = () => (
        <div style={{display: "flex", alignItems: "center", margin: 20, gap: 30}}>
            <div className="input-field outlined" style={{margin: 0}}>
                <input
                    type="text"
                    placeholder="Rechercher un évènement..."
                    style={{height: 40, width: "100%"}}
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value)
                        setPage(1)
                    }}/>
            </div>
            <label style={{display: "flex", alignItems: "center", margin: 0}}>
                <input
                    type="checkbox"
                    checked={showAll}
                    onChange={() => {
                        setShowAll(prev => !prev)
                        setPage(1)
                    }}/>
                <span style={{marginLeft: 10}}>Afficher les évènements terminés/annulés</span>
            </label>
        </div>
    )

    const renderPagination = () => (
        <div className="center" style={{margin: 20}}>
            <a className={`btn-small blue darken-2 z-depth-0 ${page === 1 ? 'disabled' : ''}`}
               onClick={() => setPage(p => Math.max(p - 1, 1))}>
                Précédent
            </a>
            <span style={{margin: "0 10px"}}>Page {page}</span>
            <a className={`btn-small blue darken-2 z-depth-0 ${medicalEvents.length < 10 ? 'disabled' : ''}`}
               onClick={() => setPage(p => p + 1)}>
                Suivant
            </a>
        </div>
    )

    const renderEvents = () => {
        if (isLoading(state)) return <div style={{marginTop: 100}}><Loader text="" size="small"/></div>
        if (hasFailed(state)) return <div style={{marginTop: 100}}>
            <Error errorText="Impossible de charger les évènements"/>
        </div>
        if (medicalEvents.length === 0) return <div style={{marginTop: 100}}>
            <h3 className="center-align">Aucun évènement n'est à venir</h3>
        </div>

        return (
            <div style={{margin: 20}}>
                <ul className="collection">
                    {medicalEvents.map(event => {
                        const date = event.date ? Helper.formatDate(event.date, "DD/MM/YYYY hh:mm") : "Date à définir";
                        return (
                            <li className="collection-item valign-wrapper" key={event.id}>
                                <div className="row valign-wrapper" style={{flex: 1}}>
                                    <div className="col s1">
                                        <span className="valign-wrapper">{renderStatus(event.status)}</span>
                                    </div>
                                    <div className="col s2"><span className="title">{date}</span></div>
                                    <div className="col s9"><span className="title">{event.name}</span></div>
                                </div>
                                <LinkHandler event={event}/>
                                <a className="btn-small blue darken-2 z-depth-0"
                                   onClick={() => nav(`/medical_events/edit/${event.id}`)}>
                                    <i className="material-icons">edit</i>
                                </a>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    return <RestrictedPage field={UserRights.USERS} permission={UserPermissions.READ_ONLY}>
        <div id="full-height" style={{display: "flex", flexDirection: "column", overflowY: "scroll"}}>
            <div className="valign-wrapper">
                <h3 className="valign-wrapper" style={{margin: 20}}>
                    <i className="material-icons left">calendar_month</i>
                    Évènements
                </h3>
                <RestrictedElement field={UserRights.USERS} permission={UserPermissions.WRITE_ONLY}>
                    <Link className="btn blue darken-2 z-depth-0"
                          style={{marginInline: 20, marginLeft: "auto"}}
                          to={"/medical_events/new"}
                    >
                        <i className="material-icons left">add</i>
                        Nouvel évènement
                    </Link>
                </RestrictedElement>
            </div>

            <div className="divider"/>
            <div style={{marginLeft: 2}}>
                {renderSearchBar()}
                {renderEvents()}
                {renderPagination()}
            </div>
        </div>
    </RestrictedPage>
}

export default MedicalEvents;